<template>
  <div v-bind:class="{'upload-page': true, 'has-uploads': uploads.length}">
    <div v-if="uploads.length > 0" class="text-center pt-3 pt-md-4">
      <button class="btn btn-primary btn-lg" v-on:click="uploadFromFile">
        <i class="fas fa-upload"></i>
        {{ t.upload_image }}
      </button>
      <div style="font-size: 90%;" class="mt-2 mb-3 mb-md-4">
        {{ t.drop_paste_text_start }}
        <a href="#" v-on:click.prevent="uploadFromUrl" class="text-dark" style="text-decoration: underline;">{{ t.drop_paste_text_url }}</a>
        {{ t.drop_paste_text_end }}
      </div>
      <hr>
    </div>
    <div class="container">
      <upload-list v-bind:uploads="uploads" v-if="uploads.length > 0" v-on:delete="deleteImage($event.key)" ref="uploadlist" v-bind:t="t" v-bind:fullImageId="fullImageId" />
      <div class="empty-state" v-if="uploads.length == 0">
        <h1 v-if="!showFreeCreditInfo">
          <span v-html="t.upload_page_heading_html"></span>
        </h1>
        <h1 v-else>
          <svg xmlns="http://www.w3.org/2000/svg" width="76.552" height="75.887" viewBox="0 0 76.552 75.887"><g transform="translate(-5.125 -5.775)"><path d="M89.723,43.28,80.481,56.407a1.788,1.788,0,1,1-2.924-2.06l.521-.741c-.322-.286-.644-.573-.971-.849-.542-.475-1.089-.93-1.631-1.37l.184-.23a15.555,15.555,0,0,0,1.355-3.118c.235.184.475.378.716.573.481.389.966.792,1.447,1.206.327.276.649.557.971.843l6.646-9.442a1.791,1.791,0,1,1,2.929,2.06Z" transform="translate(-34.388 -16.954)" fill="#454545"/><path d="M111.491,83.8a1.784,1.784,0,0,1-2.479-.5,9.015,9.015,0,0,0-6.927-4.079,12.979,12.979,0,0,0-3.006.061,13.345,13.345,0,0,0-3.154.828,4.685,4.685,0,0,0-1.288.711,1.787,1.787,0,0,1-2.525-2.53,6.732,6.732,0,0,1,1.713-1.166c-.378-.5-.777-1-1.191-1.513h-.005c-1.528-1.886-3.241-3.788-5.1-5.664l1.191-1.692.9-1.278.189.189a82.028,82.028,0,0,1,5.6,6.186q1.074,1.327,1.989,2.587a16.946,16.946,0,0,1,5.04-.281,12.593,12.593,0,0,1,9.549,5.659A1.787,1.787,0,0,1,111.491,83.8Z" transform="translate(-40.278 -29.92)" fill="#454545"/><path d="M118.585,37.055,103.327,50.24a1.789,1.789,0,1,0,2.339,2.708l15.259-13.185a1.789,1.789,0,0,0-2.339-2.708Z" transform="translate(-47.698 -15.077)" fill="#454545"/><path d="M139.523,58.909a1.278,1.278,0,0,0-1.032-.87l-3.976-.578-1.778-3.6a1.278,1.278,0,0,0-2.292,0l-1.778,3.6-3.976.578a1.278,1.278,0,0,0-.709,2.18l2.877,2.8-.679,3.96a1.278,1.278,0,0,0,1.854,1.347l3.556-1.87,3.557,1.87A1.278,1.278,0,0,0,137,66.984l-.679-3.96,2.877-2.8A1.277,1.277,0,0,0,139.523,58.909Zm-5.466,2.753a1.278,1.278,0,0,0-.368,1.131l.355,2.07-1.86-.977a1.278,1.278,0,0,0-1.189,0l-1.859.977.355-2.07a1.277,1.277,0,0,0-.368-1.131l-1.5-1.466,2.079-.3a1.279,1.279,0,0,0,.963-.7l.929-1.884.929,1.884a1.277,1.277,0,0,0,.963.7l2.079.3Z" transform="translate(-57.909 -23.155)" fill="#454545"/><path d="M25.244,15.653l-.679,3.961a1.278,1.278,0,0,0,1.855,1.347l3.556-1.87,3.556,1.87a1.279,1.279,0,0,0,1.855-1.348l-.679-3.96,2.878-2.8a1.279,1.279,0,0,0-.709-2.18L32.9,10.091l-1.778-3.6a1.278,1.278,0,0,0-2.292,0l-1.778,3.6-3.976.578a1.279,1.279,0,0,0-.709,2.18Zm2.84-3.129a1.278,1.278,0,0,0,.962-.7l.929-1.884.929,1.884a1.279,1.279,0,0,0,.962.7l2.079.3-1.5,1.466a1.278,1.278,0,0,0-.368,1.131l.355,2.07-1.859-.977a1.278,1.278,0,0,0-1.19,0l-1.859.977.355-2.07a1.276,1.276,0,0,0-.368-1.131L26,12.826Z" transform="translate(-8.239)" fill="#454545"/><path d="M60.008,57.1a12.306,12.306,0,0,0-3.67.762A14.962,14.962,0,0,1,57.958,61.4a3.616,3.616,0,0,1,.132.756l-.033.014a3.454,3.454,0,0,1-.738-.126,15.729,15.729,0,0,1-3.86-1.82,48.224,48.224,0,0,1-5.286-3.788,75.88,75.88,0,0,1-5.909-5.352,77.788,77.788,0,0,1-5.352-5.909,47.549,47.549,0,0,1-3.788-5.286,15.729,15.729,0,0,1-1.82-3.86,3.449,3.449,0,0,1-.126-.74l.013-.031a3.561,3.561,0,0,1,.751.132,15.336,15.336,0,0,1,3.865,1.82c.1.061.21.128.317.2.352.214.71.444,1.071.694a10.126,10.126,0,0,1-.833,1.318,1.789,1.789,0,0,0,2.86,2.151,13.906,13.906,0,0,0,1.7-2.988c.02-.048.037-.1.057-.145.092-.226.18-.453.261-.685.034-.1.063-.2.1-.294.06-.182.119-.365.172-.55.01-.033.021-.065.031-.1l0,0a16.978,16.978,0,0,0,.079-8.645c-1.028-4.117-3.422-7.408-6.406-8.8A1.789,1.789,0,0,0,33.7,22.6c1.987.928,3.691,3.39,4.448,6.426a13.631,13.631,0,0,1,.236,5.565l0,0q-.368-.23-.721-.445a19.228,19.228,0,0,0-4.8-2.219c-1.881-.5-3.328-.256-4.3.716a3.237,3.237,0,0,0-.893,1.734L5.274,85.716a1.789,1.789,0,0,0,2.355,2.355L58.948,65.683a3.246,3.246,0,0,0,1.754-.9c.971-.971,1.212-2.418.716-4.3A16.121,16.121,0,0,0,60.008,57.1ZM30.062,41.743a51.707,51.707,0,0,0,4.069,5.685,82.029,82.029,0,0,0,5.6,6.186,81.05,81.05,0,0,0,6.186,5.6A50.937,50.937,0,0,0,51.6,63.28c.593.36,1.16.677,1.705.96l-5.26,2.295c-8.707.274-17.164-2.486-21.9-7.223a10.137,10.137,0,0,1-3.086-5.429l6.04-13.845C29.387,40.581,29.7,41.149,30.062,41.743ZM27.335,75.57c-4.587-.131-8.1-1.248-10-3.2a4.991,4.991,0,0,1-1.319-2.34l5.533-12.683a14.892,14.892,0,0,0,2.791,3.768c3.471,3.473,9.809,6.926,18.264,7.791ZM14.668,73.133a8.351,8.351,0,0,0,.837,1.021,13.267,13.267,0,0,0,7.116,3.474L10.377,82.97Z" transform="translate(0 -6.558)" fill="#454545"/><path d="M121.6,19.633a5.118,5.118,0,1,0-5.118-5.118A5.123,5.123,0,0,0,121.6,19.633Zm0-7.679a2.562,2.562,0,1,1-2.562,2.562A2.565,2.565,0,0,1,121.6,11.954Z" transform="translate(-54.434 -1.771)" fill="#454545"/><path d="M87.025,26.019a4.555,4.555,0,1,0-4.555-4.555A4.56,4.56,0,0,0,87.025,26.019Zm0-6.554a2,2,0,1,1-2,2A2,2,0,0,1,87.025,19.465Z" transform="translate(-37.807 -5.442)" fill="#454545"/><path d="M129.653,111.852a4.555,4.555,0,1,0,4.555,4.555A4.56,4.56,0,0,0,129.653,111.852Zm0,6.554a2,2,0,1,1,2-2A2,2,0,0,1,129.653,118.406Z" transform="translate(-58.643 -51.851)" fill="#454545"/></g></svg>
          <span class="d-block mt-3" v-html="t.upload_page_heading_first_signin_html"></span>
        </h1>
        <div style="max-width: 350px;" class="mx-auto mt-5">
          <upload-widget v-on:uploadFile="uploadFromFile" v-on:uploadUrl="uploadFromUrl" v-bind:t="t" />
        </div>
        <div class="mt-5 d-flex justify-content-center">
          <div class="d-flex">
            <div class="font-weight-bold text-muted mr-2 text-left" style="font-size: 80%">
              <div>{{ t.no_image }}</div>
              <div>{{ t.try_one_of_these }}</div>
            </div>
            <div style="min-width: 176px;">
              <example-images v-on:picked="examplePicked" theme="small" />
            </div>
          </div>
        </div>
        <div style="font-size: 60%; opacity: 0.5; max-width: 385px;" class="mt-4 text-center mx-auto">
          <span v-html="t.upload_terms_html"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UploadList from './upload_list';
import UploadWidget from './upload_widget';
import ExampleImages from './example_images';

import { ImageResizer } from '@remove-bg/remove-bg-tools';

import { pickFile } from '../src/pick_file';
import { hcaptcha_invisible } from '../src/hcaptcha';
import EventBus from '../src/event_bus'

import { Base64 } from 'js-base64';

const maxConcurrent = 2;
const maxSize = 1024*1024*12;

export default {
  props: {
    t: Object,
    fullImageId: String,
    showFreeCreditInfoOnMount: Boolean,
  },
  components: { UploadList, UploadWidget, ExampleImages },
  mounted() {
    this.fetchExistingUploads();
    this.showFreeCreditInfo = this.showFreeCreditInfoOnMount;
  },
  data() {
    return {
      uploads: [],
      showFreeCreditInfo: false
    };
  },
  computed: {
    processingCount() {
      return this.uploads.filter((upload) => upload.status != 'queued' && upload.status != 'error' && upload.status != 'finished').length;
    }
  },
  methods: {
    uploadFromUrl() {
      var url = prompt(`${this.t.image_url}:`);
      window.track("Images", "upload_enter_url", "Enter URL");
      this.urlPicked(url);
    },
    urlPicked(url) {
      if(url == null || url == "") return;
      if(!url.match(/^https?:\/\/.+$/)) {
        alert(this.t.invalid_image_url);
        return;
      }
      this.enqueue({url});
    },
    examplePicked(exampleImage) {
      window.track("Images", "upload_sample_image", "Sample Image");
      this.urlPicked(exampleImage.url);
    },
    uploadFromFile() {
      pickFile().then((file) => {
        window.track("Images", "upload_select_file", "Select file");
        this.filePicked(file);
      });
    },
    filePickedBase64(filename, mimetype, base64) {
      var sliceSize = 512;
      const byteCharacters = atob(base64);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, {type: mimetype});

      this.filePicked({ file: blob, size: blob.size, type: mimetype, filename: filename }, true);
    },
    filePicked(file, isBlob = false) {
      if(file.type != "image/jpeg" && file.type != "image/png") {
        alert(this.t.only_jpg_png_supported);
        return;
      }

      if(file.size <= maxSize) {
        if(isBlob) {
          this.enqueue({ file: file.file, filename: file.filename });
        }
        else {
          this.enqueue({ file });
        }
      }
      else {
        var imageResizer = new ImageResizer(file);
        if (imageResizer.supports(file)) {
          imageResizer.reduce().then(returnObj => {
            if(blob.size > maxSize) {
              alert(this.t.max_file_size_exceeded);
              return;
            }
            this.enqueue({ file: returnObj.blob, filename: file.name, uploadingNote: this.t.image_resized });
          }).catch((error) => {
            if(window.error_tracking) window.error_tracking.sendError(error);
            alert(this.t.max_file_size_exceeded);
          });
        }
        else {
          alert(this.t.max_file_size_exceeded);
        }
      }
    },
    enqueue(upload) {
      EventBus.$emit("image-added")

      this.uploads.unshift({
        key: this.generateKey(),
        status: 'queued', // queued -> (token_requested (-> captcha_required) -> uploading -> processing -> finished) || error
        errorMessage: "",
        canSkipCaptcha: null,
        creditBalance: null,
        uploadProgress: 0.0,
        remote: {},
        ...upload
      });
      this.processQueue();
      this.showFreeCreditInfo = false

      this.$nextTick(() => {
        var uploadlist = this.$refs['uploadlist'];
        if(!uploadlist) return;
        $('html, body').animate({
          scrollTop: $(uploadlist.$el).offset().top - 90
        }, 300);
      })
    },
    processQueue() {
      if(this.uploads.length == 0 || this.processingCount >= maxConcurrent) return;
      var oldest = this.uploads.find((upload) => upload.status == 'queued');
      if(!oldest) return;
      this.process(oldest);
    },
    process(upload) {
      upload.status = 'token_requested';

      this.requestToken(upload);
    },
    requestToken(upload, tryCount=1) {
      $.ajax({
        type: 'POST',
        url: this.t.trust_tokens_url,
        data: upload.trustTokenData,
        success: (data) => {
          var useToken = (token) => {
            upload.token = token;
            this.doUpload(upload);
          }
          if(data.request && typeof(data.request) == "string") {
            eval(data.request);
          }
        },
        error: (xhr) => {
          var submitChallenge = (upload, value) => {
            upload.trustTokenData = value;
            this.requestToken(upload);
          }

          var request_hcaptcha_checkbox = (config, upload, data) => {
            upload.status = "captcha_required";
            upload.captchaConfig = {
              type: "hcaptcha_checkbox",
              config: config,
            }
            upload.canSkipCaptcha = data.can_skip_captcha;
            upload.creditBalance = data.credit_balance;
            upload.onCaptchaCompleted = (captcha) => {
              upload.status = "token_requested";
              submitChallenge(upload, {
                "proof": "hcaptcha_checkbox",
                "hcaptcha_response": captcha.value,
              });
            };
          }

          var request_hcaptcha_invisible = (config, upload, data) => {
            hcaptcha_invisible(config).then((captcha) => {
              submitChallenge(upload, {
                "proof": "hcaptcha_invisible",
                "hcaptcha_response": captcha,
              });
            }).catch((e) => {
              upload.status = "error";
              upload.errorMessage = e.message;
              this.processQueue();
            });
          }

          if(xhr.status == 422 && xhr.responseJSON && xhr.responseJSON.request && typeof(xhr.responseJSON.request) == "string") {
            eval(xhr.responseJSON.request);
          }
          else if(xhr.status == 422 && xhr.responseJSON && xhr.responseJSON.status == "invalid_csrf_token" && tryCount < 3) {
            $("meta[name='csrf-token']").attr("content", xhr.responseJSON.csrf_token);
            this.requestToken(upload, tryCount + 1)
          } else {
            upload.status = "error";
            upload.errorMessage = `Error: Failed to prepare upload (error code ${xhr.status}).\nSorry – please reload the page and try again.\nIf the problem persists, contact team@remove.bg`;
            if(window.error_tracking) {
              window.error_tracking.sendError(new Error(`Upload token request failed (try ${tryCount}): Status ${xhr.status}, Text ${(xhr.responseText ? xhr.responseText : "").substring(0,100)}`));
            }
          }
        }
      })
    },
    doUpload(upload) {
      upload.status = "uploading";
      upload.uploadProgress = 0.0;

      var formdata = new FormData();
      formdata.append('trust_token', upload.token);
      if(upload.file) {
        if(upload.filename) {
          formdata.append('image[original]', upload.file, upload.filename);
        }
        else {
          formdata.append('image[original]', upload.file);
        }
      }
      else if(upload.url) {
        formdata.append('image[original_source_url]', upload.url);
      }

      $.ajax({
        url: this.t.images_url,
        type: 'POST',
        data: formdata,
        cache: false,
        contentType: false,
        processData: false,
        xhr: () => {
          var myXhr = $.ajaxSettings.xhr()
          if(myXhr.upload) {
            myXhr.upload.addEventListener('progress', (e) => {
              if(e.lengthComputable && e.total > 0) {
                upload.uploadProgress = e.loaded / e.total;
              }
            }, false)
          }
          return myXhr;
        },
        success: (data) => {
          upload.remote = this.formatRemote(data);
          this.showResult(upload);
        },
        error: (xhr) => {
          upload.status = "error";
          upload.errorMessage = `Image Upload failed (${xhr.status}): Please try again later or select a different image.`;
          this.processQueue();
        }
      });
    },
    showResult(upload) {
      if(upload.remote.fetch_in) {
        upload.status = "processing";
        setTimeout(() => {
          $.ajax({
            type: 'GET',
            url: upload.remote.url,
            cache: false,
            success: (data) => {
              upload.remote = this.formatRemote(data);
              this.showResult(upload);
            },
            error: (xhr) => {
              upload.status = "error";
              upload.errorMessage = `Image Upload failed (${xhr.status}): Please try again later or select a different image.`;
            }
          });
        }, upload.remote.fetch_in);
      }
      else {
        upload.status = "finished";
        this.processQueue();
      }
    },
    generateKey() {
      return `${new Date().getTime()}-${Math.round(1000000000*Math.random())}`;
    },
    deleteImage(key) {
      var idx = this.uploads.findIndex((upload) => upload.key == key);
      if(idx == -1) return;
      this.uploads.splice(idx, 1);
      this.showFreeCreditInfo = false;
    },
    fetchExistingUploads() {
      $.ajax({
        url: this.t.images_url,
        type: "GET",
        success: (data) => {
          for(var i = 0; i < data.data.length; i++) {
            var upload = {
              key: data.data[i].id,
              remote: this.formatRemote(data.data[i]),
            };
            this.showResult(upload);
            this.uploads.push(upload);
          }
        },
      });
    },
    formatRemote(remote) {
      var pl = remote.pl;
      if(pl) {
        delete remote.pl;
        // We're using Base64 (https://www.npmjs.com/package/js-base64) here, because
        // "atob" does not properly decode multi-byte characters, such as Japanese zenkaku
        var plParsed = JSON.parse(Base64.decode(pl));
        remote = { ...remote, ...plParsed };
      }
      return remote;
    }
  }
}
</script>

<style scoped>
.upload-page {
  padding-bottom: 40px;
  transition: background 300ms;
}
.upload-page.has-uploads {
  background: #F7F9FA;
}
.empty-state {
  text-align: center;
  padding: 60px 0;
}
@media(min-height: 800px) { .empty-state { padding: 100px 0 100px 0; } }
@media(min-height: 900px) { .empty-state { padding: 100px 0 170px 0; } }
@media(min-height: 1000px) { .empty-state { padding: 100px 0 220px 0; } }
</style>
